import {FC, useContext} from 'react';
//formik
import {useFormikContext} from 'formik';
import {AddTableTicketFormValues} from '../formConfiguration';
//context
import {AddTableTicketContext} from '../OrganizationSignUpContext';
//mui
import {Box, Drawer, useMediaQuery} from '@mui/material';
//components
import Button from '@/shared/components/Button';
//constants
import {BACK, CANCEL, CONFIRM, CONTINUE, OUTLINE, PRIMARY, defaultStep} from '@/utils/constants';
//styles
import {addTicketActionsStyle} from './AddTicketActions.styles';
import {useAppSelector} from '@/store/hooks';
import {getUserSelector} from '@/store/user';
import {PurchaseTicketsStyle} from '@/pages/Organization/PurchaseTickets/PurchaseTickets.styles';
import {ADD_TABLE_TICKET_STEP} from '@/components/Organization/Auction/AddTableTicket/helpers';
import {useNavigate} from 'react-router-dom';

const AddTicketActions = ({isFromPage}: {isFromPage?: boolean}) => {
  const navigate = useNavigate();
  const user = useAppSelector(getUserSelector);

  const {activeStep, onCloseModal, handleBackStep} = useContext(AddTableTicketContext);
  const {submitForm} = useFormikContext<AddTableTicketFormValues>();

  const isMobile = useMediaQuery('(max-width:640px)');
  const isLaptop = useMediaQuery('(min-width:1200px)');

  const showDrawer = user || (!user && isMobile);
  const returnBack = () => navigate(-1);

  return (
    <Box>
      <Box sx={{...addTicketActionsStyle.wrapper, ...(isFromPage && addTicketActionsStyle.wrapperFromPage)}}>
        {' '}
        <Button
          title={activeStep === defaultStep ? CANCEL : BACK}
          sx={addTicketActionsStyle.button}
          onClick={activeStep === defaultStep ? (isLaptop ? onCloseModal : returnBack) : handleBackStep}
          variant={OUTLINE}
          color={PRIMARY}
          disableRipple
        />
        <Button
          title={activeStep === ADD_TABLE_TICKET_STEP.ATTENDEES_INFO ? CONFIRM : CONTINUE}
          sx={addTicketActionsStyle.button}
          onClick={submitForm}
          disableRipple
        />
      </Box>

      {showDrawer && (
        <Drawer variant="permanent" anchor="bottom" sx={PurchaseTicketsStyle.drawer}>
          <Box sx={PurchaseTicketsStyle.popup}>
            <Button
              title={activeStep === ADD_TABLE_TICKET_STEP.ATTENDEES_INFO ? CONFIRM : CONTINUE}
              onClick={submitForm}
            />
            <Button
              title={activeStep === defaultStep ? CANCEL : BACK}
              onClick={activeStep === defaultStep ? (isLaptop ? onCloseModal : returnBack) : handleBackStep}
              variant={OUTLINE}
              color={PRIMARY}
            />
          </Box>
        </Drawer>
      )}
    </Box>
  );
};

export default AddTicketActions;
